import { IReadme } from '_/common/types/readme.types';
import { IEditor, INameEntity, ISlugEntity, Nullable } from '_/types/common.types';
import { IDelivery } from '_/types/deliveries/delivery.types';
import { IOrgEntity } from '_/types/organizations/organization.types';
import { IProject } from '_/types/projects/project.types';

export enum EFlowType {
  CHAINED = 'CHAINED',
  LEGACY = 'LEGACY',
  SIMPLE = 'SIMPLE',
}

export interface IFlowDefinitionChain {
  chunkCollectHours?: number;
  collectionId: string;
  dataHours?: number;
  keyTransform?: string;
  transform?: string;
}

export interface IFlowDefinition {
  aggregateChunks?: boolean;
  chainingParameter?: string;
  chains?: IFlowDefinitionChain[];
  chunkCollectHours?: number;
  chunkPushHours?: number;
  chunkTimeoutHours?: number;
  chunks: number;
  collectionId: string;
  ignoreAggregationDupes?: boolean;
  inputTransform?: string;
  inputUriTemplate?: string;
  retainOriginalChunkFiles?: boolean;
}

export interface ISourceCriteriaFilter extends Record<string, unknown> {
  parameters: Record<string, string>;
}

export interface ISourceCriteria {
  filters: ISourceCriteriaFilter[];
}

export interface IFlowBaseConfig extends IOrgEntity {
  closeHours: number;
  dataHours: number;
  pushHours: number;
  skipQaTests: boolean;
  sourceCriteria: Nullable<ISourceCriteria>;
}

export interface IFlowDelivery extends IFlowBaseConfig, IDelivery {
  deliveryId: string;
  flowDefinition: IFlowDefinition;
  flowId: string;
}

export interface IFlow extends IFlowBaseConfig, INameEntity, ISlugEntity {
  active: boolean;
  cron: string;
  definition: IFlowDefinition;
  editor?: IEditor;
  encryptedConfig: Nullable<Record<string, string>>;
  project?: IProject;
  projectId: string;
  readme: Nullable<IReadme>;
  type: EFlowType;
}
